import React from "react";
import * as Yup from "yup";
import { ETLCodes } from "../../locales";
import { useTl } from "../useTl";

// Characters that can legitimately appear in a phone number. Ported from
// IFAPME.Walter.Frontend/src/utils/phoneRegex.tsx, without the g/m flags:
// Yup.matches() calls regex.test(), which is stateful when `g` is set.
export const phoneRegex = /^[+\d/\-. ]*$/;

export const useValidators = () => {
  const { t } = useTl();

  const dataTranslationValidator = React.useMemo(
    () =>
      Yup.object().shape({
        dataTranslationValues: Yup.array().of(
          Yup.object().shape({
            text: Yup.string()
              .nullable()
              .when("languageCode", {
                is: "EN",
                then: (schema) => schema.required(t(ETLCodes.Required)),
                otherwise: (schema) => schema,
              }),
          })
        ),
      }),
    [t]
  );

  // Format only: emptiness is handled by the callers' required()/test() rules.
  const phoneValidator = React.useMemo(
    () => Yup.string().nullable().matches(phoneRegex, t(ETLCodes.ErrorPhoneRegex)),
    [t]
  );

  const emailValidator = React.useMemo(
    () => Yup.string().nullable().email(t(ETLCodes.InvalidEmail)),
    [t]
  );

  // Memoized: callers put `validators` in their own useMemo deps, so a new
  // object on every render would rebuild their validation schemas each time.
  return React.useMemo(
    () => ({
      dataTranslationValidator,
      phoneValidator,
      emailValidator,
    }),
    [dataTranslationValidator, emailValidator, phoneValidator]
  );
};
